const MS_PER_DAY = 86_400_000

function startOfUtcDay(d: Date): Date {
  return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()))
}

/**
 * Mirrors campaign-service `linkTokenExpiresAtFromCampaignEnd` —
 * campaign is valid through the end UTC calendar day (expires at start of next day).
 */
export function campaignEndExpiryInstant(endDateIso: string): Date | null {
  const end = new Date(endDateIso)
  if (!Number.isFinite(end.getTime())) return null
  const dayStart = startOfUtcDay(end)
  return new Date(dayStart.getTime() + MS_PER_DAY)
}

/** True when the campaign end UTC calendar day has passed. */
export function hasCampaignEndDatePassed(
  endDate: string | null | undefined,
  now: Date = new Date(),
): boolean {
  if (!endDate) return false
  const expiresAt = campaignEndExpiryInstant(endDate)
  if (!expiresAt) return false
  return now.getTime() >= expiresAt.getTime()
}
